import { Facebook } from '@mui/icons-material';

export default function Footer() {
	return (
		<div className='flex flex-col w-full py-4 mt-auto shadow-lg bg-primary'>
			<div className='px-4 sm:px-0 container flex items-center pb-2 mx-auto'>
				<div className='flex flex-col gap-2  sm:grid w-full sm:grid-cols-3 text-white full'>
					<div className='flex flex-col justify-start gap-4'>
						<div className='flex flex-col'>
							<span>Tlf: 33 06 66 00</span>
							<a href='https://www.dahl.no/samferdsel' target='_blank' rel='noopener noreferrer'>dahl.no/samferdsel</a>
						</div>
					</div>
					<div className='flex flex-col justify-start gap-4'>
						<a className='flex items-center gap-2 mt-auto' href='https://www.facebook.com/BDSamferdsel' target='_blank' rel='noopener noreferrer'>
							<Facebook />
							<span>Følg oss på Facebook</span>
						</a>
					</div>
				</div>
			</div>
			<div className='w-full bg-tertiary'>
				<div className='px-4 sm:px-0 container flex items-center justify-between py-4 mx-auto text-white'>
					<div className='copyright'>
						Copyright {new Date().getFullYear()}{' '}
						<a href='https://docs.bdsamferdsel.no/' title='Brodrene Dahl'>
							<span>Brodrene Dahl</span>
						</a>
						. All rights reserved. Powered by{' '}
						<a href='https://baezeni.com' target='_blank' title='Baezeni CO,.Ltd.' rel='noopener noreferrer'>
							<span>Baezeni Co,.Ltd.</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
